import * as FileManager from '../../SDK/FileManager'
import * as DeliveryManager from '../../SDK/DeliveryManager'
import * as Util from '../../common/js/util'

const deliveryTransfor = {
  state: {
    isShow: false,
    title: '请选择要转存的位置',
    isRoot: true,
    currentPath: '',
    content: [],
    currentFolder: {},
    isShowCreate: false,
    isSuccess: false,
    isBackReload: false,
    linkInfo: {}
    // linkInfo: {
    //   'uid': '33',
    //   'neid': '379',
    //   'nsid': '33',
    //   'path': '/测试xls.xls',
    //   'mode': 'rp',
    //   'protected': false,
    //   'password': '',
    //   'expiration': '-1',
    //   'type': 'file',
    //   'description': '',
    //   'ctime': '2018-01-26 17:29:54',
    //   'mtime': '2018-01-30 11:14:26',
    //   'counter_download': '1',
    //   'counter_upload': '0',
    //   'counter_preview': '0',
    //   'is_checked_watermark': '0',
    //   '_id': 'c0911a8979474edd8ae77bce1a7fff3e',
    //   'filename': '测试xls.xls',
    //   'url': 'http://172.16.52.67/link/view/c0911a8979474edd8ae77bce1a7fff3e',
    //   'account_expiration': false,
    //   'user_name': 'gyn',
    //   'preview': {
    //     'rev': '03f9c690c0354251bd66f50b7ea73861',
    //     'desc': '',
    //     'bytes': 18944,
    //     'preview_url': 'http://172.16.52.67:10081/v2/wopi/delivery/c0911a8979474edd8ae77bce1a7fff3e/?mimetype=.xls&neid=379&user_name=gyn',
    //     'updator': 'gyn',
    //     'delivery_creator_uid': 33,
    //     'creator': 'gyn',
    //     'data_url': 'http://idt.lenovows.com/delivery/data/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'thumb_exist': false,
    //     'delivery_code': 'c0911a8979474edd8ae77bce1a7fff3e',
    //     'mime_type': 'doc/.xls',
    //     'download_url': 'http://172.16.52.67:10081/v2/delivery/data/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'path': '/测试xls.xls',
    //     'client_mtime': '2018-01-30T11:17:50+0800',
    //     'delivery_desc': '',
    //     'neid': 379,
    //     'lock_uid': 0,
    //     'hash': '31c1fdc1a8e958df8f59fab9809b7e32',
    //     'delivery_mtime': '2018-01-30T11:14:26+0800',
    //     'watermarkDownloadUrl': '',
    //     'upload_url': 'http://172.16.52.67:10081/v2/delivery/data/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'downLoad_available': true,
    //     'metadata_url': 'http://172.16.52.67/v2/delivery/metadata/c0911a8979474edd8ae77bce1a7fff3e/',
    //     'delivery_creator': 'gyn',
    //     'access_mode': 1029,
    //     'modified': '2018-01-24T10:25:55+0800',
    //     'size': '18.5 KB',
    //     'is_shared': false,
    //     'is_dir': false
    //   },
    //   'canview': 1,
    //   'thumb_exist': false
    // }
  },
  getters: {
    getLinkInfo: state => state.linkInfo
  },
  mutations: {
    setIsBackReload (state, obj) {
      state.isBackReload = obj
    },
    setdeliverySuccess (state, obj) {
      state.isSuccess = obj
    },
    setTitle (state, obj) {
      state.title = obj
    },
    setdeliveryIsRoot (state, obj) {
      state.isRoot = obj
    },
    setdeliveryIsShow (state, obj) {
      state.isShow = obj
    },
    setDeliveryCurrentPath (state, obj) {
      state.currentPath = obj
    },
    getList (state, obj) {
      state.linkInfo = obj
    },
    getTransforList (state, obj) {
      state.currentFolder = obj
      state.content = []
      var contents = obj.content
      for (let i = 0; i < contents.length; i++) {
        var file = {}
        var item = contents[i]
        var d = Util.resolvePath(item.path, item.is_dir)
        item.type = d.type
        item.typeIcon = Util.typeIcon(d.type)
        item.name = d.name
        item.title = file.name
        item.filename = file.name
        item.size = Util.formatBytes(item.bytes)
        item.datetime = Util.formatDate(item.modified || item.datetime, 'yyyy-MM-dd' + ' hh:mm')
        item.authName = Util.getAuthNameByAccessMode(item.access_mode).authName
        if (item.dir_type === 2 || item.dir_type === 4) { // 2代表云端共享文件夹  4代表云端普通文件夹
          item.is_cloud = true
          if (item.dir_type === 2) {
            item.is_shared = true
          }
        } else {
          item.is_cloud = false
        }
        if (item.is_dir) {
          if (item.is_shared && item.is_team) {
            item.typeIcon = 'folder_team'
          } else if (item.is_shared && item.is_cloud) { // 云端文件被共享
            item.typeIcon = 'cloud_share'
          } else if (item.is_cloud) { // 云端文件
            item.typeIcon = 'folder_cloud'
          } else if (item.is_shared) {
            item.typeIcon = 'folder_share'
          } else if (item.is_team) {
            item.typeIcon = 'folder_team'
          } else {
            item.typeIcon = 'folder'
          }
        }
        switch (item.dir_type) {
          case 1 :
            item.category = '团队文件夹'
            break
          case 2 :
            item.category = '云端共享文件夹'
            break
          case 4 :
            item.category = '云端文件夹'
            break
          case 6 :
            item.category = '共享文件夹'
            break
          case 8 :
            item.category = '普通文件'
            break
          default :
            item.category = '普通文件夹'
            break
        }
        if (item.is_dir) {
          state.content.push(item)
        }
      }
    }
  },
  actions: {
    getTransforList ({commit}, obj) {
      FileManager.metaData(obj.params).then(response => {
        commit('getTransforList', response)
      }, err => {
        console.log(err)
      })
    },
    // getDeliveryData ({commit}, obj) {
    //   DeliveryManager.deliveryMetaData(obj.params).then(response => {
    //     commit('getdumpList', response)
    //   }, err => {
    //     console.log(err)
    //   })
    // },
    deliveryTransforAddFolder ({commit, rootState, dispatch}, obj) {
      let params = {
        path: '/' + rootState.deliveryTransfor.currentFolder.path + '/' + obj,
        path_type: rootState.deliveryTransfor.currentFolder.path_type,
        prefix_neid: rootState.deliveryTransfor.currentFolder.prefix_neid,
        from: rootState.deliveryTransfor.currentFolder.from
      }
      FileManager.createFolder(params).then(response => {
        commit('setAddFolderShow', false)
        let params = {path: rootState.deliveryTransfor.currentFolder.path,
          path_type: rootState.deliveryTransfor.currentFolder.path_type,
          prefix_neid: rootState.deliveryTransfor.currentFolder.prefix_neid,
          from: rootState.deliveryTransfor.currentFolder.from,
          limit: 1000,
          content_type: 'dir'
        }
        dispatch({
          type: 'getTransforList',
          params: params
        })
      }, err => {
        if (err.type === 'error') {
          commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
        }
      })
    },
    deliveryTransfor ({commit}, obj) {
      DeliveryManager.deliveryTransfor(obj.params).then(response => {
        commit('setdeliverySuccess', true)
        commit('setToast', {isShow: true, message: '转存成功', iconClass: 'icon-success'})
      }, err => {
        commit('setdeliverySuccess', false)
        commit('setProgress', {isShow: false})
        commit('setToast', {isShow: true, message: err.message, iconClass: 'icon-error'})
      })
    },
    getInfo ({commit}, obj) {
      let info = window.localStorage.getItem('linkInfo')
      commit('getList', info)
      // window.localStorage.removeItem('linkInfo')
    }
  }
}
export default deliveryTransfor



// WEBPACK FOOTER //
// ./src/store/modules/deliveryTransfor.js